export default __webpack_public_path__ + "static/media/vin.ab021181.svg";